import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard-page page section py-5" }
const _hoisted_2 = { class: "dashboard-mobile is-hidden-desktop" }
const _hoisted_3 = { class: "columns is-mobile is-multiline" }
const _hoisted_4 = { class: "column is-6" }
const _hoisted_5 = { class: "column is-6" }
const _hoisted_6 = { class: "column is-6" }
const _hoisted_7 = { class: "column is-6" }
const _hoisted_8 = { class: "column is-12" }
const _hoisted_9 = { class: "w-100 dashboard-history mb-5" }
const _hoisted_10 = { class: "w-100 dashboard-history" }
const _hoisted_11 = { class: "columns section-1 is-desktop is-hidden-touch" }
const _hoisted_12 = { class: "column is-7-desktop h-100" }
const _hoisted_13 = { class: "columns indicators m-0" }
const _hoisted_14 = { class: "column p-0 is-3" }
const _hoisted_15 = { class: "column p-0 is-3" }
const _hoisted_16 = { class: "column p-0 is-3" }
const _hoisted_17 = { class: "column p-0 is-3" }
const _hoisted_18 = { class: "map w-100" }
const _hoisted_19 = { class: "column is-5-desktop is-5-widescreen" }
const _hoisted_20 = { class: "columns is-multiline section-2" }
const _hoisted_21 = { class: "column is-12-desktop is-6-widescreen is-hidden-touch dashboard-history" }
const _hoisted_22 = { class: "column is-12-desktop is-6-widescreen is-hidden-touch dashboard-history" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardHeader = _resolveComponent("DashboardHeader")!
  const _component_widget_indicator_gas_alarm = _resolveComponent("widget-indicator-gas-alarm")!
  const _component_widget_indicator_trouble = _resolveComponent("widget-indicator-trouble")!
  const _component_widget_indicator_offline = _resolveComponent("widget-indicator-offline")!
  const _component_widget_indicator_ok = _resolveComponent("widget-indicator-ok")!
  const _component_dashboard_events_chart = _resolveComponent("dashboard-events-chart")!
  const _component_dashboard_offline_chart = _resolveComponent("dashboard-offline-chart")!
  const _component_n_tab_pane = _resolveComponent("n-tab-pane")!
  const _component_widget_station_table = _resolveComponent("widget-station-table")!
  const _component_widget_map = _resolveComponent("widget-map")!
  const _component_n_tabs = _resolveComponent("n-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DashboardHeader),
    _createCommentVNode(" MOBILE "),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_n_tabs, {
        class: "dashboard-tabs",
        size: "large",
        type: "line",
        "justify-content": "space-evenly",
        animated: "",
        "pane-wrapper-class": "h-100",
        "pane-wrapper-style": "margin: 0 -4px",
        "pane-style": "padding-left: 4px; padding-right: 4px; box-sizing: border-box;"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_n_tab_pane, {
            class: "dashboard-tab",
            name: _ctx.TabEnum.ALARMS,
            tab: _ctx.$t('dashboard.alarms'),
            "display-directive": "if"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_widget_indicator_gas_alarm)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_widget_indicator_trouble)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_widget_indicator_offline)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_widget_indicator_ok)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_dashboard_events_chart)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_dashboard_offline_chart)
                  ])
                ])
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["name", "tab"]),
          _createVNode(_component_n_tab_pane, {
            class: "dashboard-tab",
            name: _ctx.TabEnum.DEVICES,
            tab: _ctx.$t('dashboard.devices'),
            "display-directive": "if"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_widget_station_table, { class: "widget-device-list" })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["name", "tab"]),
          _createVNode(_component_n_tab_pane, {
            class: "dashboard-tab",
            name: _ctx.TabEnum.MAP,
            tab: _ctx.$t('dashboard.map.title'),
            "display-directive": "if"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_widget_map, {
                stations: _ctx.stations,
                loading: _ctx.loading
              }, null, 8 /* PROPS */, ["stations", "loading"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["name", "tab"])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createCommentVNode(" DESKTOP "),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_widget_indicator_gas_alarm)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_widget_indicator_trouble)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_widget_indicator_offline)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_widget_indicator_ok)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_widget_map, {
            stations: _ctx.stations,
            class: "h-100"
          }, null, 8 /* PROPS */, ["stations"])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_widget_station_table, { class: "widget-device-list" })
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_dashboard_events_chart)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_dashboard_offline_chart)
      ])
    ])
  ]))
}